import { Button } from '@/components/ui/button'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu'
import EntitySettings from 'app/frontend/base/components/EntitySettings'
import Section from 'app/frontend/base/components/Section'
import { useGuild } from 'app/frontend/base/config/context/guild'
import { compareTeamsByDefaultAndName } from 'app/frontend/base/helpers/teamOrdering'
import { useNavigate } from 'react-router-dom'
import AccessSection from './components/sections/AccessSection'
import CustomDomainSection from './components/sections/CustomDomainSection'
import GuildSection from './components/sections/GuildSection'
import PremiumSection from 'app/frontend/base/pages/TeamDashboard/subpages/TeamSettings/components/sections/PremiumSection'
import { useGameVersion } from 'app/frontend/base/hooks/useGameVersion'

const GuildSettings = () => {
  const { guild } = useGuild()
  const navigate = useNavigate()
  const gameVersion = useGameVersion()
  const teams = [...(guild?.teamReferences ?? [])].sort(
    compareTeamsByDefaultAndName,
  )

  return (
    <Section title={`Settings | ${guild?.name}`}>
      <EntitySettings
        entityType='guild'
        titleAction={
          teams.length ? (
            <DropdownMenu modal={false}>
              <DropdownMenuTrigger asChild>
                <Button variant='outline' size='sm'>
                  Team settings
                </Button>
              </DropdownMenuTrigger>
              <DropdownMenuContent>
                {teams.map((team) => (
                  <DropdownMenuItem
                    key={team.id}
                    onClick={() => navigate(`${team.path}/settings`)}
                  >
                    {team.name}
                  </DropdownMenuItem>
                ))}
              </DropdownMenuContent>
            </DropdownMenu>
          ) : null
        }
        sections={{
          guild: GuildSection,
          access: AccessSection,
          custom_domain: CustomDomainSection,
          ...(gameVersion.has('blizzard_api')
            ? { premium: PremiumSection }
            : {}),
        }}
      />
    </Section>
  )
}

export default GuildSettings
